import React, { type MouseEvent } from 'react';
import { Manager as PopperManager, Reference as PopperReference } from '@atlaskit/popper';
import type OriginTracing from '@atlassiansox/origin-tracing';

import HoverPreview from '../hover-preview';
import TemplatesSidebar from '../project-pages-improvement/templates-sidebar';
import messages from './messages';
import { type Template } from '../../containers/template/types';

export interface OwnProps {
	containerRef: React.RefObject<HTMLElement>;
	templates: Template[];
	onTemplateClick?: (template: Template) => void;
	onTemplateMouseEnter?: (template: Template) => void;
	onMouseLeave?: () => void;
	isDisabled: boolean;
	origin: OriginTracing | null;
	hoverPreviewProps?: {
		onMouseEnter: (event: MouseEvent) => void;
		onMouseLeave: (event: MouseEvent) => void;
		template?: Template;
	};
}
// If hover preview props are undefined, send noop functions for the mouse events
// so no unexpected errors are thrown
const noopHoverProps = {
	onMouseEnter: (event: MouseEvent) => {},
	onMouseLeave: (event: MouseEvent) => {},
};

export const TemplatesPanelHoverPreview = ({
	containerRef,
	templates,
	onTemplateClick,
	onTemplateMouseEnter,
	onMouseLeave,
	isDisabled,
	origin,
	hoverPreviewProps = noopHoverProps,
}: OwnProps) => (
	<PopperManager>
		<PopperReference>
			{({ ref }) => (
				<TemplatesSidebar
					hoverRef={ref}
					onTemplateClick={onTemplateClick}
					onTemplateMouseEnter={onTemplateMouseEnter}
					onMouseLeave={onMouseLeave}
					isDisabled={isDisabled}
					origin={origin}
					templates={templates}
					title={messages.hasConfluenceLicenseTitle}
					subtitle={messages.hasConfluenceLicenseSubTitle}
				/>
			)}
		</PopperReference>
		<HoverPreview boundaryRef={containerRef} {...hoverPreviewProps} />
	</PopperManager>
);
